import React from 'react';
import { RawHtml } from '../../';
import PropTypes from 'prop-types';
import { daysBetween } from '../../../../utils/helpers/CommonHelper';
import { useTranslation } from 'react-i18next';
import { ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Link, useNavigate } from 'react-router-dom';

const CalendarListItem = ({
  from,
  to,
  title_sk,
  title_en,
  isBachelor,
  isEngineer,
  isDoctor,
  showTime,
  url,
  onClose, // pridaj prop onClose
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dateFrom = dayjs(from);
  const dateTo = to ? dayjs(to) : dayjs(from);
  const range = daysBetween(dateFrom, dateTo) !== 0;

  return (
    <div className="calendar-list-item-container add-icons-to-file-anchors">
      <div className="content-wrapper">
        <div className="date">
          <span>
            {`${dateFrom.format('D.M.YYYY')}${
              (range && ` - ${dayjs(dateTo).format('D.M.YYYY')}`) || ''
            }`}
          </span>
        </div>
        <div className="slovak">
          <RawHtml>{title_sk}</RawHtml>
        </div>
        <div className="english">
          <RawHtml>{title_en}</RawHtml>
        </div>
        {url && (
          <Link
            to={url}
            className="more-info"
            onClick={(e) => {
              e.preventDefault();
              if (onClose) {
                onClose();
                setTimeout(() => navigate(url), 300);
              } else {
                navigate(url);
              }
            }}
          >
            ...viac info
          </Link>
        )}
        <div className="bonus-info">
          {showTime && (
            <>
              <ClockCircleOutlined />
              {dateFrom.format('H:mm')}
            </>
          )}
          {isBachelor && <span>{t('Bakalárska')} &nbsp; </span>}
          {isEngineer && <span>{t('Inžinierska')} &nbsp; </span>}
          {isDoctor && <span>{t('Doktorandská')} &nbsp;</span>}
        </div>
      </div>
    </div>
  );
};

CalendarListItem.propTypes = {
  from: PropTypes.object,
  to: PropTypes.any,
  title_sk: PropTypes.string,
  title_en: PropTypes.string,
  isBachelor: PropTypes.bool,
  isEngineer: PropTypes.bool,
  isDoctor: PropTypes.bool,
  showTime: PropTypes.bool,
  url: PropTypes.string,
  onClose: PropTypes.func,
};

export default CalendarListItem;
